import React from 'react';
import { Clock3, PackageCheck, Truck, MapPin } from 'lucide-react';

const features = [
  { icon: Clock3, text: 'Same Day Printing' },
  { icon: PackageCheck, text: 'Bulk Orders Available' },
  { icon: Truck, text: 'Pan India Dispatch' },
  { icon: MapPin, text: 'Fort Mumbai' },
];

const TrustStrip = () => {
  return (
    <section className="w-full bg-black text-white py-5 sm:py-6">
      <div className="container mx-auto px-4 sm:px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {features.map((item, index) => {
            const Icon = item.icon;
            return (
              <div
                key={index}
                className="flex flex-col items-center justify-center text-center rounded-xl border border-white/10 bg-white/5 px-3 py-4 sm:px-4 sm:py-5 min-h-[110px]"
              >
                <Icon className="w-6 h-6 sm:w-7 sm:h-7 text-green-400 mb-2" />
                <span className="text-sm sm:text-base font-semibold leading-snug">
                  {item.text}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default TrustStrip;
